/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Rounds_Choice_PodInputs */



/**
* | output |
* | --- |
* | "FFA" |
*
* @param {Tournaments_Lib_Rounds_Choice_PodInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_rounds_choice_pod = /** @type {((inputs?: Tournaments_Lib_Rounds_Choice_PodInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Rounds_Choice_PodInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("FFA")
	if (locale === "fr") return /** @type {LocalizedString} */ ("FFA")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("乱斗")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("混戰")
	if (locale === "ko") return /** @type {LocalizedString} */ ("FFA")
	return /** @type {LocalizedString} */ ("FFA")
});